
































































































































import { Component, Vue, Watch } from "vue-property-decorator";

class IcwLogFilters {
  q: string = "";
  method: string = "";
  admin_user_email: string = "";
  path: string = "";
  response_status: string = "";
  request_payload: string = "";
  created_from: string = "";
  created_to: string = "";
}

interface IcwLog {
  id?: number;
  log_id?: number;
  method?: string;
  path?: string;
  admin_user_email?: string;
  response_status?: number | string;
  created_at?: string;
  request?: any;
  request_body?: any;
  request_payload?: any;
  payload?: any;
  response?: any;
  response_body?: any;
  response_data?: any;
  response_payload?: any;
  admin_user_name?: string;
  admin_user_role?: string;
  url?: string;
  route_name?: string;
  route_action?: string;
  route_parameters?: any;
  ip_address?: string;
  user_agent?: string;
  duration_ms?: number | string;
}

@Component
export default class Logs extends Vue {
  logs: IcwLog[] = [];
  totalLogs: number = 0;
  loading: boolean = false;
  options: any = {
    page: 1,
    itemsPerPage: 20,
  };
  filters: IcwLogFilters = new IcwLogFilters();
  filterDebounce: any = null;
  methods: string[] = ["GET", "POST", "PUT", "PATCH", "DELETE"];

  headers = [
    { text: "Id", value: "id" },
    { text: "Method", value: "method" },
    { text: "Path", value: "path" },
    { text: "Admin", value: "admin_user_name" },
    { text: "Admin E-posta", value: "admin_user_email" },
    { text: "Status", value: "response_status" },
    { text: "Response", value: "response_payload", sortable: false },
    { text: "Süre (ms)", value: "duration_ms" },
    { text: "Tarih", value: "created_at" },
    { text: "", value: "data-table-expand" },
  ];

  @Watch("options", { deep: true })
  onOptionsChange() {
    this.loadLogs();
  }

  @Watch("filters", { deep: true })
  onFiltersChange() {
    clearTimeout(this.filterDebounce);
    this.filterDebounce = setTimeout(() => {
      this.applyFilters();
    }, 500);
  }

  created() {
    this.loadLogs();
  }

  applyFilters() {
    if (this.options.page !== 1) {
      this.options.page = 1;
      return;
    }

    this.loadLogs();
  }

  clearFilters() {
    this.filters = new IcwLogFilters();
    this.applyFilters();
  }

  async loadLogs() {
    try {
      this.loading = true;
      const params = this.buildParams();
      const response = await this.$http.get(`${this.$store.state.icwApiUrl}admin/logs`, { params });
      const responseData = response.data || {};

      if (Array.isArray(responseData.data)) {
        this.logs = this.normalizeLogs(responseData.data);
        this.totalLogs = responseData.total || responseData.data.length;
      } else if (responseData.data && Array.isArray(responseData.data.data)) {
        this.logs = this.normalizeLogs(responseData.data.data);
        this.totalLogs = responseData.data.total || responseData.data.data.length;
      } else if (Array.isArray(responseData)) {
        this.logs = this.normalizeLogs(responseData);
        this.totalLogs = responseData.length;
      } else {
        this.logs = [];
        this.totalLogs = 0;
      }
    } catch (error) {
      console.error("İcraproWeb logları yüklenirken hata oluştu:", error);
      this.$toast.error("İcraproWeb logları yüklenirken bir hata oluştu.");
    } finally {
      this.loading = false;
    }
  }

  buildParams() {
    const { page, itemsPerPage } = this.options;
    const params: any = {
      page: page || 1,
      per_page: itemsPerPage || 20,
    };

    Object.keys(this.filters).forEach((key) => {
      const value = this.filters[key as keyof IcwLogFilters];
      if (value !== null && value !== undefined && `${value}`.trim() !== "") {
        params[key] = value;
      }
    });

    return params;
  }

  normalizeLogs(items: IcwLog[]) {
    return items.map((item) => ({
      ...item,
      id: item.id || item.log_id,
    }));
  }

  formatAdminUser(item: IcwLog) {
    const role = item.admin_user_role ? ` (${item.admin_user_role})` : "";
    return `${item.admin_user_name || "-"}${role}`;
  }

  routeDetail(item: IcwLog) {
    return {
      url: item.url,
      route_name: item.route_name,
      route_action: item.route_action,
      route_parameters: item.route_parameters,
    };
  }

  clientDetail(item: IcwLog) {
    return {
      ip_address: item.ip_address,
      user_agent: item.user_agent,
      duration_ms: item.duration_ms,
    };
  }

  hasResponseError(item: IcwLog) {
    return !!(item.response_payload && item.response_payload.error);
  }

  statusColor(status: number | string) {
    const numericStatus = Number(status);
    if (numericStatus >= 200 && numericStatus < 300) {
      return "green";
    }
    if (numericStatus >= 400) {
      return "red";
    }
    if (numericStatus >= 300) {
      return "orange";
    }

    return "grey";
  }

  formatDetail(value: any) {
    if (!value) {
      return "-";
    }

    if (typeof value === "string") {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    }

    return JSON.stringify(value, null, 2);
  }
}
